import { render, staticRenderFns } from "./row-image.vue?vue&type=template&id=0824e94c&scoped=true"
import script from "./row-image.vue?vue&type=script&lang=js"
export * from "./row-image.vue?vue&type=script&lang=js"
import style0 from "./row-image.vue?vue&type=style&index=0&id=0824e94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0824e94c",
  null
  
)

export default component.exports